import {
  ManagedBy,
  PrimaryAction,
  TestCard,
} from "@app/provider/testData/types";
import { OrganHealthTestCardBase } from "@app/provider/testData/testCard/organHealth/OrganHealthTestCardBase";
import { IntlShape } from "react-intl/src/types";
import { messages } from "@app/provider/testData/messages";
import {
  getProsperaEbdd,
  hasProsperaEbddPassed,
} from "@app/utils/prosperaEbdd";
import { convertSampleCollectionDate } from "@app/utils";

export class ProsperaTestCard extends OrganHealthTestCardBase {
  protected getDescriptionForUpcomingTest(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    const ebdd = getProsperaEbdd(testCard);
    if (
      testCard.managedBy === ManagedBy.NATERA &&
      !testCard.isProReach &&
      ebdd
    ) {
      return hasProsperaEbddPassed(testCard)
        ? intl.formatMessage(messages.testCardDescProsperaEbddPassed)
        : intl.formatMessage(messages.testCardProsperaScheduleAroundEbdd, {
            resultExpectedByDate: convertSampleCollectionDate(
              ebdd.toISOString()
            ),
          });
    }
    return super.getDescriptionForUpcomingTest(testCard, intl);
  }

  protected getDescriptionForResultReady(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    return intl.formatMessage(messages.testCardDescResultReadyReview);
  }

  protected getPrimaryActionForUpcomingTest(
    testCard: TestCard
  ): PrimaryAction | undefined {
    if (
      testCard.managedBy === ManagedBy.NATERA &&
      !testCard.isProReach &&
      !hasProsperaEbddPassed(testCard)
    ) {
      return PrimaryAction.SCHEDULE_A_DRAW;
    }
  }

  protected getPrimaryActionForKitShipped(
    testCard: TestCard
  ): PrimaryAction | undefined {
    return PrimaryAction.TRACK_KIT_STATUS;
  }
}
